















































































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { toStyleVal, isNumeric } from '@/utils';

@Component
export default class AxButton extends Vue {
  @Prop({ type: String, default: null })
  width!: string;

  @Prop({ type: String, default: null })
  height!: string;

  @Prop({ type: String, default: 'rgba(0,0,0,0.25)' })
  color!: string;

  @Prop({ type: String, default: null })
  icon!: string;

  @Prop({ type: Boolean, default: false })
  big!: boolean;

  @Prop({ type: Boolean, default: false })
  extra!: boolean;

  @Prop({ type: Boolean, default: false })
  lighten!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Emit()
  click() {
    return;
  }

  get styleVal() {
    const color = this.color !== '' ? this.color : '';
    const width = isNumeric(this.width) ? this.width + 'px' : this.width;
    const height = isNumeric(this.height) ? this.height + 'px' : this.height;

    return toStyleVal([
      ['background', color],
      ['min-width', width],
      ['min-height', height]
    ]);
  }

  get id() {
    if (this.extra) return 'ax-button-extra';
    else if (this.big) return 'ax-button-big';
    else return 'ax-button';
  }

  get attrVal() {
    return {
      id: this.id,
      width: this.width,
      height: this.height,
      minWidth: this.width,
      minHeight: this.height,
      color: 'rgba(0, 0, 0, 0)',
      tile: true,
      depressed: true,
      disabled: this.disabled,
      dark: !this.lighten
    };
  }
}
